export default {
  'acc102.cashProjection': '現金残高見込',
  'acc102.cashTaxIncluded': '税込現金残高',
  'acc102.cashTaxExcluded': '税抜現金残高',
  'acc102.cashReceivable': '売掛金見込（税込）',
  'acc102.cashTaxReserve': '消費税留保額（概算）',
  'acc102.cashKnown': '既知の現金残高',
  'acc102.cashBaseline': '基準月末残高',
  'acc102.cashRange': '推計対象期間',
  'acc102.cashOpening': '期首現金残高',
  'acc102.cashMovement': '期間収支増減',
  'acc102.cashClosing': '期末現金残高',
  'acc102.cashProjectionNotice':
    '税込現金は2026年9月末3400万円を基準に、請求書支払期限で入金予測します。期限なしは所属月の2か月後。未到来の入金は売掛金とし、現金に含めません。税額は未回収分も発生月に留保し、税抜現金＝税込現金－2026年1月以降の累計留保額です。仕入税額・納付済税額を控除せず、手入力額も税分解しません。経営概算であり、納税額や実入金ではありません。基準前へ遡及しません。',
  'acc102.cashBeforeBaseline': '基準月以前のため、現金残高を遡及推計しません。',
  'acc102.cashOutOfRange': '現金残高の推計可能範囲を超えています。近い期間を選択してください。',
  'acc102.cashIncomplete': 'コスト要確認の月があるため、それ以降の残高は未確定です',
  'acc102.fixedExpenses': '固定支出',
  'acc102.fixedExpensesNotice':
    '2026年の各月へ設定額を計上します。実際の支払記録ではなく、翌年以降へ自動継続しません。同じ費用を手入力しないでください。',
  'acc102.fixedExpenseAmount': '月額固定費',
  'acc102.fixed.UR': 'UR',
  'acc102.fixed.UTILITIES': '光熱水費・ごみ収集費',
  'acc102.fixed.REPAYMENT_1': '返済1',
  'acc102.fixed.WITHHOLDING_TAX': '個人源泉所得税',
  'acc102.fixed.LOCAL_TAX': '地方税',
  'acc102.fixed.OFFICE': '事務所',
  'acc102.fixed.AWS': 'AWS',
  'acc102.fixed.TEAMS': 'Teams',
  'acc102.fixed.CODEX': 'Codex',
  'acc102.fixedFxNotice':
    '予算換算：{currency} {amount} × {rate} JPY/{currency}。参考日：{date}。円単位四捨五入、実際の引落額ではなく、税・手数料を追加しません。過去月を自動再換算しません。',
  'acc102.estimated': '（見込）',
  'acc102.referenceMonth': '参照月',
  'acc102.invoiceAuto': '請求収入（税抜）',
  'acc102.invoiceAutoNotice':
    '営業部の請求書一覧の税抜額を所属月へ計上します。未発行の見込も含みます。原請求書・入金は変更せず、実入金を重複計上しません。同じ収入を手入力しないでください。',
  'acc102.commuteAuto': '交通費',
  'acc102.commuteAutoNotice':
    '未提出・承認待ち・承認済み・差戻しを含む全申請額を計上します。全月未申請の場合のみ、対象月より前の直近完了月を見込として参照月付きで計上します。申請のある月は補完しません。重複入力しないでください。',
  'acc102.companyId': '会社ID',
  'acc102.applications': '申請件数',
  'acc102.invoiceForecastAmount': '税抜額（見込含む）',
  'acc102.commuteAmount': '申請額',
  'acc102.manualStatus': '手入力の状態',
  'acc102.salaryPeriodTotal': '検索期間内の登録済み実付額',
  'menu.accounting.income-expense': '損益対照',
  'acc102.pageTitle': '損益対照',
  'acc102.INCOME': '収入',
  'acc102.EXPENSE': '支出',
  'acc102.MANUAL': '手入力',
  'acc102.INVOICE': '請求書',
  'acc102.SALARY': '給与',
  'acc102.DRAFT': '入力待ち',
  'acc102.CONFIRMED': '登録済み',
  'acc102.VOID': '無効',
  'acc102.add': '手入力追加',
  'acc102.edit': '編集',
  'acc102.save': '保存',
  'acc102.cancel': 'キャンセル',
  'acc102.confirm': '確認',
  'acc102.void': '無効化',
  'acc102.confirmPrompt': '実際の入出金として確認しますか？',
  'acc102.voidPrompt': 'この記録を無効にしますか？集計から除外されます。',
  'acc102.completeFirst': '先に実際の日付と金額を保存してください。',
  'acc102.confirmedEdit': '確認済み記録の編集は実績集計に即時反映されます。',
  'acc102.direction': '収支区分',
  'acc102.title': '名称',
  'acc102.targetMonth': '表示対象月',
  'acc102.sourceMonth': '給与所属月',
  'acc102.cashDate': '実際日付',
  'acc102.amount': '実際金額',
  'acc102.remarks': '備考',
  'acc102.status': '状態',
  'acc102.actions': '操作',
  'acc102.baseSalary': '基本給（参考）',
  'acc102.allowance': '特別手当（参考）',
  'acc102.missingReference': '給与資料は要確認です。参考額は実付に転記されません。',
  'acc102.required': '必須項目を入力してください。',
  'acc102.invalid':
    '入力を確認してください。金額は1〜9,999,999,999,999の整数、日付は日本の本日以前です。',
  'acc102.empty': '該当する記録はありません。',
  'acc102.emptyINCOME': '現在の条件に該当する収入記録はありません',
  'acc102.emptyINCOMEHint':
    '請求書一覧の税抜額（未発行の見込を含む）を所属月へ自動計上します。その他の収入は手入力できます。',
  'acc102.emptyEXPENSE': '現在の条件に該当する支出記録はありません',
  'acc102.emptyEXPENSEHint':
    '給与の会社総コストと通勤費の全申請額を所属月へ自動計上します。その他の支出は手入力できます。',
  'acc102.sourceNotice':
    '既存の請求書・給与参考は自動計上されません。参照元または手入力から実際の日付・金額を入力して保存すると、追加の確認操作なしで集計されます。',
  'acc102.saveNotice':
    '保存すると実際の収支へ即時反映し、請求書の入金状態も更新します。実際の日付と金額を確認してください。',
  'acc102.saved': '処理が完了しました。',
  'acc102.receipts': '入金明細',
  'acc102.addReceipt': '入金追加',
  'acc102.invoice': '請求書番号',
  'acc102.company': '会社名',
  'acc102.invoiceAmount': '請求額（税込）',
  'acc102.received': '登録済み入金',
  'acc102.remaining': '未収残額',
  'acc102.billingMonth': '請求月',
  'acc102.reload': '再読込',
  'acc102.invoiceSources': '請求書から選択',
  'acc102.history': '過去の入金済み請求書も含む',
  'acc102.legacyNotice':
    '旧入金状態は最初の実入金保存まで維持されます。保存後は新しい入金明細が状態を管理します（後で無効化しても旧状態には戻りません）。',
  'acc102.salaryImport': '給与取込',
  'acc102.import': '取込',
  'acc102.batchDate': '支払日を一括設定',
  'acc102.salaryNotice':
    '給与参考だけを取り込み、実際の日付・金額は空欄のまま集計対象外です。各人の実際の日付・金額を入力して保存すると計上されます。再取込は既存の値を上書きしません。',
  'acc102.batchNotice':
    '現在の検索結果にある、この所属月の入力待ち記録の日付だけを変更し、集計はしません。金額を補完して各人を保存してください。登録済み・無効の記録と実付額は変更しません。',
  'acc102.cashNotice':
    '実際の日付・金額を入力して保存すると集計されます。入力待ちは合計に含みません。概算や正式な財務諸表ではありません。',
  'acc102.month': '月次',
  'acc102.year': '年次',
  'acc102.allStatuses': 'すべての状態',
  'acc102.selectedTotal': '選択月の収支',
  'acc102.annualTotal': '年間収支',
  'acc102.balance': '差額',
  'acc102.pending': '要確認件数',
  'acc102.companyCost': '会社総コスト',
  'acc102.companyCostNotice':
    '給与管理と同じ会社総コスト（保険見込・案件収入0の10万円ルールを含む）を所属月へ計上します。請求・交通費も所属月、手入力のみ実際日付で集計します。会社負担を重複登録しないでください。',
  'acc102.automaticCost': '自動計上',
  'acc102.costReview': 'コスト要確認',
  'acc102.costBasis': '計算基準',
  'acc102.fixedCost': '案件収入0：10万円固定',
  'acc102.standardCost': '標準コスト',
  'acc102.accountId': '社員ID',
  'acc102.employee': '社員名',
  'acc102.employees': '名',
  'acc102.monthDetails': '12か月明細',
  'acc102.unpaid': '未入金',
  'acc102.partial': '一部入金済み',
  'acc102.paid': '入金済み',
  'acc102.error.ACC102_INVALID': '入力内容を確認してください。金額・日付・対象月が不正です。',
  'acc102.error.ACC102_NOT_FOUND': '記録が見つかりません。入力を控え、再読込してください。',
  'acc102.error.ACC102_CONFLICT':
    '他の更新と競合しています。入力を確認し、最新の記録を再読込してください。',
  'acc102.error.ACC102_OVERPAYMENT':
    '確認済み入金の合計が請求額を超えます。残額を確認してください。',
  'acc102.error.ACC102_SOURCE_CHANGED':
    '参照元が変更されています。入力を保ったまま参照元を再確認してください。',
  'acc102.error.ACC102_LEGACY_DISABLED':
    '旧入金更新は停止しました。再読込して入金明細を利用してください。',
  'acc102.error.forbidden': 'この操作を行う権限がありません。',
  'acc102.error.unauthorized': 'ログイン期限が切れました。再度ログインしてください。',
  'acc102.error.failed':
    '取得・処理に失敗しました。入力は保持されています。通信状況を確認して再試行してください。',
};
